module.exports = __webpack_public_path__ + "img/dick3_slide_1.ce213a36.jpg";